'use client';

import { cn } from '@/shared/lib/cn';
import { useSelectedCurrency } from '@/shared/lib/hooks/useSelectedCurrency';
import { AnimatedPrice } from '@/shared/ui/animated-price';
import { SummaryItemT } from './types';

type Props = SummaryItemT & {
    isDiscount?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
};
export const CartSummaryBoxItem = ({ name, price, type, tipId, isFirst, isLast, isDiscount }: Props) => {
    const [selectedCurrency] = useSelectedCurrency();
    const amount = typeof price.amount === 'string' ? parseFloat(price.amount) : price.amount;

    return (
        <tr
            className={cn(
                'cart-summary-box__row',
                isFirst && 'cart-summary-box__row--border-top',
                isLast && 'cart-summary-box__row--border-bottom',
                isDiscount && 'cart-summary-box__row--discount',
            )}
            data-testid="cart-summary-item"
            data-type={type}
            data-tip-id={tipId}
        >
            <th align="left" data-testid="cart-summary-item-name">
                {name}
            </th>
            <td
                align="right"
                data-testid="cart-summary-item-price"
                data-amount={price.amount}
                data-currency={selectedCurrency}
            >
                {/* Breakdown lines show their true value (decimals only when present:
                    270 → "270", 13.5 → "13,5"); rounding is applied only once, on the
                    grand total — see OMP-2166. */}
                <AnimatedPrice
                    amount={amount}
                    currency={selectedCurrency}
                    minimumFractionDigits={0}
                    maximumFractionDigits={2}
                />
            </td>
        </tr>
    );
};
